/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DrawnLine from '../partials/DrawnLine';
import DrawnCircle from '../partials/DrawnCircle';
import { useIntersectionObserver } from '../../hooks/useObserver';
import Html from '../partials/Html';

import styles from '../../../styles/blocks/quote.module.scss';
import Link from '../partials/Link';
import ExternalLinkIcon from '../icons/ExternalLink';

const propTypes = {
    id: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    author: PropTypes.string,
    theme: PropTypes.oneOf(['line', 'circle']),
    align: PropTypes.oneOf(['left', 'center', 'right']),
    url: PropTypes.string,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    authorClassName: PropTypes.string,
};

const defaultProps = {
    author: null,
    theme: 'line',
    align: null,
    url: null,
    className: null,
    isContainer: false,
    containerClassName: null,
    contentClassName: null,
    authorClassName: null,
};

const QuoteBlock = ({
    id,
    body,
    author,
    theme,
    align,
    url,
    className,
    isContainer,
    containerClassName,
    contentClassName,
    authorClassName,
}) => {
    const [animate, setAnimate] = useState(false);

    const {
        ref,
        entry: { isIntersecting = false },
    } = useIntersectionObserver({ rootMargin: '-20%' });

    useEffect(() => {
        if (isIntersecting) {
            setAnimate(true);
        }
    }, [isIntersecting]);

    const inner = (
        <>
            {author !== null ? (
                <p
                    className={classNames([
                        styles.author,
                        { [authorClassName]: authorClassName !== null },
                    ])}
                >
                    -{author}
                </p>
            ) : null}
            {url !== null ? <ExternalLinkIcon className={styles.linkIcon} /> : null}
        </>
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles[`${align}Align`]]: align,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
                ref={ref}
            >
                <div
                    className={classNames([
                        styles.content,
                        { [contentClassName]: contentClassName !== null },
                    ])}
                >
                    {theme === 'line' ? (
                        <DrawnLine className={styles.line} id={`${id}-line`} drawn={animate} />
                    ) : null}
                    {theme === 'circle' ? (
                        <DrawnCircle
                            className={styles.circle}
                            id={`${id}-circle`}
                            drawn={animate}
                        />
                    ) : null}
                    <Html tag="blockquote" className={styles.body} body={body} />
                </div>
                {url !== null ? (
                    <Link href={url} className={styles.source} external>
                        {inner}
                    </Link>
                ) : (
                    <div className={styles.source}>{inner}</div>
                )}
            </div>
        </div>
    );
};

QuoteBlock.defaultProps = defaultProps;
QuoteBlock.propTypes = propTypes;

export default QuoteBlock;
